module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/1_img@3x-0d97d274098e4709a3dccc8a640cadbd.png";